// third-party

// assets
import { DotChartOutlined, IdcardOutlined } from '@ant-design/icons';

// type
import { NavItemType } from 'types/menu';

// icons
const icons = {
  DotChartOutlined,
  IdcardOutlined
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const mapBuilder: NavItemType = {
  id: 'map-builder',

  icon: icons.IdcardOutlined,
  type: 'group',
  children: [
    {
      id: 'map-build',
      title: 'Map builder',
      type: 'item',
      url: '/map-builder/',
      icon: icons.DotChartOutlined,
      breadcrumbs: true
    }
  ]
};

export default mapBuilder;
